import { DirectiveType } from '../../types';
import { AbstractMultiValueDirective } from '../abstract-multi-value-directive';
export class PrefetchSource extends AbstractMultiValueDirective {
    getDirectiveName() {
        return 'prefetch-src';
    }
    getDirectiveType() {
        return DirectiveType.Fetch;
    }
    getMinimumCspVersion() {
        return 3;
    }
}
